<template>
	<div class="cents">
		<van-nav-bar title="审核管理" left-arrow safe-area-inset-top style="background-color: #1ABC9C;"
			@click-left="goto" />
		<div class="requist">
			<van-field :border="true" clearable size="large" v-model="keyword" placeholder="设备名或者位置" />
			<van-button color="#1ABC9C" size="small" @click='questlist'>查询</van-button>
		</div>
		<van-list
		    v-model="loading"
		    :finished="finished"
		    :finished-text="$t('mygd')"
		    @load="loadMore"
		>
			<div v-for="item in faceList" :key="item.id" class="personItem">
				<img v-if="item.face_url" :src="headerImgUrl+item.face_url" class="itemImg" />
				<img v-else src="../../images/selectfile.png" class="itemImg" />
				<div class="itemInfoBox">
					<div class="itemInfo">
						<div class="itemName">{{item.name}}</div>
						<div class="itemMobile" v-if="item.mobile">({{item.mobile}})</div>
					</div>
					<div class="itemInfo">
						<div class="itemDept">部门：{{item.dept_name}}</div>
					</div>
					<div style="text-align: left;" v-if="item.card_no">卡号：{{item.card_no}}</div>
				</div>
				<div class="itemBtn" @click="handleDle(item.id,item.approve_state)">{{item.approve_state?'已审核':'审核'}}</div>
			</div>
		</van-list>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	export default {
		data() {
			return {
				headerImgUrl: "https://web.fondcard.net/static",
				UserInfo: JSON.parse(window.localStorage.getItem("getTokendata")), // 本地缓存 获取用户数据
				keyword: '', // 搜索框 绑定值
				faceList: [], // 列表数据
				personId: '', // 点击人员的 id
				loading:false,
				finished: false,
				page_index:0,
				count:null,
			}
		},
		watch:{
			keyword(newVal){
				if(newVal==''){
					this.faceList = []
					this.finished = false;
					this.getList()
				}
			}
		},
		mounted() {
			// this.getList()
		},
		methods: {
			// 获取更多列表
			loadMore() {
			    this.page_index++;
			    this.getList()
			},
			// 审核接口
			toExamine(id){
				let data = {
					method:'co.person.more.approve',
					id:id,
					agent_id: this.UserInfo.agent_id,
					manager_id: this.UserInfo.manager_id,
				}
				this.$https(data).then(res=>{
					if(res.data.code==0){
						Toast.success('审核成功')
						// this.faceList.forEach(item=>{
						// 	if(item.id==id){
						// 		item.approve_state=1
						// 	}
						// })
						// this.page_index=0
						// this.faceList = []
						this.page_index=1
						this.faceList = []
						this.finished = false;
					}else{
						Toast.fail('错误码'+res.data.code)
					}
				})
			},
			// 点击按钮 审核
			handleDle(id, approve_state) {
				console.log(id, approve_state);
				this.personId = id
				if (approve_state == 0) { // 审核
					this.toExamine(id)
					
					this.getList()
				}
			},
			// 获取列表数据 接口
			getList() {
				let data = {
					method: 'co.approve.list',
					page_index: this.page_index,
					page_size: 10,
					name: this.keyword,
					mobile:'',
					dept_id:-1,
					agent_id: this.UserInfo.agent_id,
					manager_id: this.UserInfo.manager_id,
					approve_status:-1
				}
				this.$https(data).then(res => {
					if(res.data.code==0){
						this.loading = false;
						this.count = res.data.count
						if (res.data.data.length==0 || this.count === 0) {
						    // 加载结束
						    this.finished = true;
						    return;
						}
						
						this.faceList = this.faceList.concat(res.data.data)
						
						if (this.faceList.length >= this.count) {
						    this.finished = true;
						}
					}
					
				})
			},
			// 点击查询
			questlist() {
				this.page_index=1
				this.faceList = []
				this.getList()
			},
			// 返回上一页
			goto() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped>
	.personItem {
		display: flex;
		border-bottom: 1px solid #ccc;
		padding: 10px 0;
	}

	.itemImg {
		width: 65px;
		height: 65px;
		border-radius: 50%;
		margin: 0 20px 0 10px;
	}

	.itemInfoBox {
		/* padding-top: 10px; */
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}

	.itemInfo {
		font-size: 15px;
		display: flex;
		width: 200px;
	}

	.itemName {
		flex: 3;
		display: flex;
		justify-content: flex-start;
	}

	.itemMobile {
		flex: 7;
		display: flex;
		justify-content: flex-start;
	}

	.itemBtn {
		background-color: #1ABC9C;
		width: 60px;
		height: 35px;
		color: #fff;
		border-radius: 5px;
		line-height: 35px;
		text-align: center;
		margin: auto;
		font-size: 14px;
	}

	.requist {
		width: 80%;
		margin: 0 auto;
		margin-top: 30px;
		margin-bottom: 30px;
		display: flex;
		justify-content: space-around;
	}

	.requist>>>.van-cell {
		width: 180px;
		border: 1px solid #ccc;
		padding: 4px 6px;
		border-radius: 4px;
	}

	.cents>>>.van-nav-bar__title {
		color: #fff;
	}

	.cents>>>.van-nav-bar .van-icon {
		color: #fff;
	}
</style>
